module.exports = __webpack_public_path__ + "img/cannery.f68d7d3d.svg";